import SmartTableContent from './smart-table-content';
import './smart-table-content.scss';

export default SmartTableContent;
